import { Injectable } from '@angular/core';
import { Log } from '../../models/common/log.model';

@Injectable({ providedIn: 'root' })
export class LogService {
  logError(log: Log): void {
    log;
  }
}
